module.exports = __webpack_public_path__ + "static/media/Icn-gif.c25f907b.svg";